<script setup>
</script>

<template>
  <div id="app">
    <router-view />
  </div>
</template>

<style>
/* 全局样式已在style.css中定义 */
</style>
